import { render, staticRenderFns } from "./BeatLoader.vue?vue&type=template&id=5fb03d27&"
import script from "./BeatLoader.vue?vue&type=script&lang=js&"
export * from "./BeatLoader.vue?vue&type=script&lang=js&"
import style0 from "./BeatLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports